import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../util/api";

export const fetchParameters = createAsyncThunk("userParameters/fetchParameters", async () => {
    const response = await api.get(`v2/api/profile/parameters/`).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});
export const uploadProfilePic = createAsyncThunk("userParameters/updateParameters", async ({formData}) => {
    const response = await api
        .post(`v2/api/profile/upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
    return response.data;
});
export const updateParameters = createAsyncThunk("userParameters/updateParameters", async ({values}) => {
    const response = await api.put(`v2/api/profile/parameters/`, {parameters: values}).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});

export const getLanguageId = createAsyncThunk(
    "context/getLanguageId",
    async (code) => {
        const response = await api.get(`v2/api/settings/language/${code}`).catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
        
        return response.data;
    },
    {
        condition: (args, {getState, extra}) => {
            const {context} = getState();
            if (context.status.type === "loading") {
                // Already fetched or in progress, don't need to re-fetch
                return false;
            }
        },
    }
);

const initialState = {
    credential: {},
    languageId: null,
    status: {
        type: "idle",
        error: null,
    },
};

const userParametersSlice = createSlice({
    name: "userParameters",
    initialState,
    reducers: {
        setInitialState: state => initialState,
    },
    extraReducers: {
        [fetchParameters.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [fetchParameters.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.credential = action.payload.data;
        },
        [fetchParameters.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },

        [uploadProfilePic.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [uploadProfilePic.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.credential = action.payload.data;
        },
        [uploadProfilePic.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },

        [updateParameters.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [updateParameters.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.credential = action.payload.data;
        },
        [updateParameters.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
        [getLanguageId.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [getLanguageId.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.languageId = action.payload.data?.id;           
        },
        [getLanguageId.rejected]: (state, action) => {
            state.status.type = "failed";
        },
    },
});

export const {setInitialState} = userParametersSlice.actions;
export default userParametersSlice.reducer;

export const selectAllParameters = state => state.credential.parameters;
export const selectAllParametersTypes = state => state.credential.types;
export const loadUserLanguageParameter = state => state.userParameters.languageId;
